import ProductTable from "components-base/productos/components/ProductTable";
import TallasTable from "components-base/tallas/components/TallasTable";
import InsumoTable from "components-base/insumos/components/InsumoTable";
import TelasTable from "components-base/telas/components/TelaTable";

export const tabsElement = [
  {
    label: "Diseño",
    component: <ProductTable />,
  },
  {
    label: "Catálogo de Habilitados",
    component: <InsumoTable />,
  },
  {
    label: "Catálogo de Tallas",
    component: <TallasTable />,
  },
  {
    label: "Catálogo  de Telas",
    component: <TelasTable />,
  },
];
